/**
 * Branding Configuration
 * 
 * Centralized branding strings for the application.
 * Update this file to white-label the app.
 */

export const BRANDING = {
  // Primary app name
  name: 'PLOT PLANET',
  
  // Short name for compact displays
  shortName: 'PP',
  
  // Tagline shown under logo
  tagline: 'Your Story Universe',
  
  // Logo configuration
  logo: {
    iconName: 'logo-saturn',  // Icon component name for brand identity
    text: 'PLOT PLANET',
  },
  
  // Meta/SEO
  meta: {
    title: 'Plot Planet Dashboard',
    description: 'Plot Planet - Story management platform for creative projects',
  },
  
  // Footer text
  footer: 'A story management platform',
  
  // Default content templates
  defaults: {
    synopsisTitle: 'PLOT PLANET — Synopsis',
    projectName: 'My Project',
  },
}

/**
 * Get full page title with app name
 * @param {string} page - Page name to prefix
 * @returns {string} Full page title
 */
export function getPageTitle(page) {
  return page ? `${page} | ${BRANDING.name}` : BRANDING.meta.title
}

// Export individual commonly-used values for convenience
export const APP_NAME = BRANDING.name
export const APP_LOGO_ICON_NAME = BRANDING.logo.iconName
export const APP_LOGO_TEXT = BRANDING.logo.text
export const APP_TAGLINE = BRANDING.tagline
